export default __webpack_public_path__ + "static/media/Maintenance.1f77a91f.svg";